<template>
  <div class="container" ref="container" style="min-height: 500px;">
    <div v-if="isLoading">
      <img src="../../assets/img/yulan.png" alt="" class="bg">
      <div class="box1">
        <div class="left">
          <img :src="headimg" alt="">
        </div>
        <div class="right">
          <h1>{{ user.user_real_name }}</h1>
          <p>
            {{ user.sex | sex }}
            <span>|</span>{{ user.birthday | birthday }}<span>|</span>{{ user.address_name | address }}
          </p>
          <div v-if="isShow">
            <span><i class="iconfont icondianhua"></i>{{ user.phone }}</span>
            <span><i class="iconfont iconweibiaoti554"></i>{{ user.email }}</span>
          </div>
        </div>
      </div>
      <div class="box2">
        <h2 class="title">个人标签</h2>
        <div class="list">
          <div>
            <span>所属领域:</span>
            <div>
              <i class="label-text" v-for="(item,index) in lingyu" :key="index">{{ item }}</i>
            </div>
          </div>
          <div>
            <span>期望职位:</span>
            <div>
              <i class="label-text" v-for="(item,index) in zhiwei" :key="index">{{ item }}</i>
            </div>
          </div>
          <div>
            <span>期望薪资:</span>
            <div>
              <i class="label-text">{{ xingziqiwang }} K * {{ month_money }}个月</i>
            </div>

          </div>
        </div>
      </div>


      <div v-if="resumeId">
        <!--      <div class="box2" v-if="data.resume.industry">-->
        <!--        <h2 class="title">目前职业概况</h2>-->
        <!--        <div class="list">-->
        <!--          <div>-->
        <!--            <span>所属领域:</span>{{data.resume.industry}}-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <span>所任职位:</span>{{data.resume.position}}-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <span>机构名称:</span>{{data.resume.organization_name}}-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <span>税前年薪:</span>{{data.resume.show_annual_salary === 0?'****':data.resume.annual_salary}} 万-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <div class="box2" v-if="data.resume.holp_work_site">
          <h2 class="title">职业发展意向</h2>
          <div class="list">
            <!--          <div>-->
            <!--            <span>期望工作性质:</span>{{data.resume.work_type | type}}-->
            <!--          </div>-->
            <div>
              <span>期望地点:</span>{{ data.resume.holp_work_site }}
            </div>
            <div>
              <span>期望领域:</span>{{ data.resume.holp_field }}
            </div>
            <div>
              <span>期望年薪:</span>{{ data.resume.holp_salary }}
            </div>
            <!--          <div>-->
            <!--            <span>期望职位:</span>{{data.resume.holp_industry_cn}}-->
            <!--          </div>-->
            <!--          <div>-->
            <!--&lt;!&ndash;            <span>勿推机构:</span>{{data.resume.shield_organization_cn}}&ndash;&gt;-->
            <!--          </div>-->
          </div>
        </div>
        <div class="box2" v-if="data.workHistory.length>0">
          <h2 class="title">工作经历</h2>
          <div class="items" v-for="(item,index) in data.workHistory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.workHistory.length"></div>
            <div class="time">{{ item.start_time | time }} - {{ item.end_time | time }}</div>
            <div class="list">
              <div style="width: 100%">
                {{ item.organization_name }}
              </div>
              <div>
                <span>机构类型:</span>{{ item.origanization_type_cn }}
              </div>
              <div>
                <span>所在地区:</span>{{ item.district_cn }}
              </div>
              <div>
                <span>机构规模:</span>{{ item.scale_cn }}
              </div>
              <div>
                <span>所属领域:</span>{{ item.industry_cn }}
              </div>
              <div>
                <span>所在部门:</span>{{ item.branch_cn }}
              </div>
              <div>
                <span>职位:</span>{{ item.jobs_name }}
              </div>
              <div>
                <span>下属人数:</span>{{ item.underling }}
              </div>
              <div>
                <span>汇报对象:</span>{{ item.report_obj_cn }}
              </div>
              <div>
                <span>税前月薪:</span>{{ item.nian_xin_lock === 1 ? '****' : item.nian_xin }} K
              </div>
              <div style="width: 100%">
                <span>离职原因:</span>{{ item.leave_offer }}
              </div>
              <div style="width: 100%">
                <span>工作职责<br/>和业绩:</span>{{ item.job_duty }}
              </div>
              <div style="width: 100%">
                <span>机构描述:</span>{{ item.organization_detail }}
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.projectHsitory.length>0">
          <h2 class="title">项目经历</h2>
          <div class="items" v-for="(item,index) in data.projectHsitory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.projectHsitory.length"></div>
            <div class="time">{{ item.start_time | time }} - {{ item.end_time | time }}</div>
            <div class="list">
              <div style="width: 100%">
                {{ item.title }}
              </div>
              <div style="width: 100%">
                <span>项目描述:</span>{{ item.content }}
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.educationHsitory.length>0">
          <h2 class="title">最高学历</h2>
          <div class="items items2" v-for="(item,index) in data.educationHsitory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.educationHsitory.length"></div>
            <div class="list">
              <div style="width: 100%">
                <span style="width: 30%">{{ item.school }}</span>
                <span style="width: 10%;padding-left: 10px;">{{ item.education_cn }}</span>
                <span style="width: 20%;padding-right: 10px;">{{ item.speciality }}</span>
                <span style="width: 10%">{{ item.is_tong === 1 ? '统招' : '非统招' }}</span>
                <span style="width: 20%" class="times">{{ item.start_time | time }} - {{ item.end_time | time }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.english_hear !== 0">
          <h2 class="title">语言能力</h2>
          <div class="list">
            <div style="width: 100%">
              <span>英语:</span> 听<b>{{ data.resume.english_hear | lang }}</b>说<b>{{
                data.resume.english_speak | lang
              }}</b>读<b>{{
                data.resume.english_read
                  | lang
              }}</b>写<b>{{ data.resume.english_write | lang }}</b>
            </div>
            <div style="width: 100%">
              <span>中文:</span> 沟通能力 <b>{{ data.resume.chinese_speak | lang }}</b> 写作能力 <b>{{
                data.resume.chinese_write |
                  lang
              }}</b>
            </div>
            <div v-for="(item, index) in data.resume.other_language" :key="index">
              <span>{{ item.name }}:</span>{{ item.option }}
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.img_ids.length>0">
          <h2 class="title">相关证书</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b v-for="(item,index) in data.resume.img_ids" :key="index">{{ item }}</b>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.lable_ids.length>0">
          <h2 class="title">专业技能</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b v-for="(item,index) in data.resume.lable_ids" :key="index">{{ item }}</b>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.accessory_name">
          <h2 class="title">附件简历</h2>
          <div class="list">
            <div style="width: 100%;">
              <a :href="data.resume.accessory_path" style="color: #00a2ea;"
                 target="_blank">{{ data.resume.accessory_name }}</a>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.file_url && Number(data.resume.type)===2">
          <h2 class="title">附件简历</h2>
          <div class="list">
            <div style="width: 100%;">
              <a :href="data.resume.file_url" style="color: #00a2ea;"
                 target="_blank">{{ data.resume.title }}</a>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.self_eval">
          <h2 class="title">自我评价</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b>{{ data.resume.self_eval }}</b>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.cover">
          <h2 class="title">求职信</h2>
          <h3 style="text-align: center;font-size: 28px;font-weight: 500;margin-bottom: 20px;">{{
              data.cover.title
            }}</h3>
          <div class="ql-editor" v-html="data.cover.content"></div>
        </div>
      </div>
      <div v-if="resume_link">
        <a :href="resume_link" style="
       display: block;
       width: 120px;
              height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 20px auto;
    background: rgb(0, 162, 234);
    color: rgb(255, 255, 255);
    border: 1px solid #ddd;
    cursor: pointer;
">点击下载简历</a>
      </div>
      <div class="box3">
        <div @click="back" style="background: #00a2ea;color: #fff;">返回列表</div>
        <!--        <div @click="biaoqianShade=true">添加标签</div>-->
        <!--        <div @click="baogaoShade = true">添加/修改面试报告</div>-->
        <div @click="toJubao">举报该简历</div>
        <div v-if="states === 1" @click="setResumeState(4,'搁置')">搁置</div>
        <div v-if="states === 1||states === 2||states === 9||states === 4" @click="setResumeState(3,'拒绝')">拒绝</div>
        <div v-if="states === 1||states === 2||states === 9||states === 4" @click="setResumeState(5,'录用')">录用</div>
        <div v-if="states === 5">已录用</div>
        <div v-if="states === 3">已拒绝</div>
      </div>
      <el-dialog custom-class="baogao-shade" append-to-body :close-on-click-modal="false" :visible.sync="baogaoShade">
        <div class="dialogBox">
          <div class="title">面试报告</div>
          <div class="list">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm">
              <el-form-item label="标题" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="desc">
                <el-input type="textarea" v-model="ruleForm.desc" rows="6"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="sub-btn" @click="submitForm('ruleForm')">立即创建</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
      <el-dialog custom-class="baogao-shade" append-to-body :close-on-click-modal="false" :visible.sync="biaoqianShade">
        <div class="dialogBox">
          <div class="title">简历标签</div>
          <div class="list-lable">
            <div class="label-item" v-for="(item,index) in lableList" :key="index" :class="{active:item.state}"
                 @click="clickLabel(item.tag_id)">
              <span>{{ item.tag_name }}</span>
              <b>+{{ item.count }}</b>
              <i class="iconfont iconzan"></i>
            </div>
          </div>
          <div class="add-other">
            <p>自定义标签</p>
            <div>
              <el-input v-model="labelName" placeholder="请输入自定义标签（2-6个字）"
                        style="width: 250px;margin-right: 20px;"></el-input>
              <el-button type="primary" @click="addLabel">确定</el-button>
            </div>
          </div>
          <!--          <el-button type="primary" class="sub-btn">保存提交</el-button>-->
        </div>
      </el-dialog>
      <el-dialog width="30%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="dialogBox">
          <div class="title" style="margin-bottom: 30px;"> 面试信息填写</div>
          <el-form :model="msForm" :rules="msrules" ref="msForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="面试时间" prop="msTime">
              <el-date-picker
                v-model="msForm.msTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="选择面试时间"
                :picker-options="pickerOptions0"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="失效时间" prop="sxTime">
              <el-date-picker
                v-model="msForm.sxTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                placeholder="选择失效时间"
                :picker-options="pickerOptions0"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="机构联系人" prop="name">
              <el-input v-model="msForm.name"></el-input>
            </el-form-item>
            <el-form-item label="机构联系电话" prop="tel">
              <el-input v-model="msForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="视频面试:" prop="videoInterview">
              <el-radio-group v-model="msForm.videoInterview">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="机构地址" prop="address" v-if="msForm.videoInterview === '否'">
              <el-input v-model="msForm.address"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="sub-btn" :disabled="isSubmit"
                         style="width:120px;position: relative;left: -60px;" @click="submitForm2('msForm')">发送面试邀请
              </el-button>
            </el-form-item>
          </el-form>
          <p style="color: #d50000;line-height: 24px;" v-if="data.deliver_methods!==1">
            注：此简历邀请面试需冻结咸豆，如果候选人拒绝面试或未参加面试，咸豆将退回余额</p>
        </div>
      </el-dialog>


      <el-dialog
        title="视频面试二维码，请打开微信扫一扫"
        center
        :visible.sync="dialogVisible"
        append-to-body
        :close-on-click-modal="false"
        width="40%"
      >
        <img :src="msImg" alt="" style="display: block;margin: 0 auto">
      </el-dialog>
    </div>
  </div>
</template>

<script>
import config from '../../config/index'

export default {
  data() {
    var vmsTime = (rule, value, callback) => {
      console.log(new Date().getTime() - new Date(value).getTime())
      if (value === '') {
        callback(new Error('请选择面试时间'));
      } else if (new Date().getTime() >= new Date(value)) {
        callback(new Error('不能选择当天'));
      } else {
        if (this.msForm.sxTime !== '') {
          this.$refs.msForm.validateField('sxTime');
        }
        callback();
      }
    };
    var vsxTime = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择失效时间'));
      } else if (new Date() >= new Date(value)) {
        callback(new Error('不能选择当天'));
      } else if (value.getTime() / 1000 >= this.msForm.msTime.getTime() / 1000) {
        callback(new Error('失效时间需小于面试时间!'));
      } else {
        callback();
      }
    };
    return {
      resumeId: '',
      resume_link: '',
      isLoading: false,
      isShow: false,     //  是否显示联系方式
      headimg: '',      //  头像
      data: {},         //  简历数据
      states: '',        //  简历状态  1：处理中、2：面试邀请、3：拒绝、4：被搁置、5：录用、6：未面试、7：已面试、8：拒绝面试、9：同意面试、
      user: {},          //  候选人信息
      lingyu: [],
      zhiwei: [],
      xingziqiwang: '',
      month_money: '',
      baogaoShade: false,//  面试报告显示
      jobuserId: '',
      ruleForm: {
        name: '',
        desc: ''
      },  //  面试报告表单
      rules: {
        name: [
          {required: true, message: '请填写标题', trigger: 'blur'},
        ],
        desc: [
          {required: true, message: '请填写内容', trigger: 'blur'}
        ]
      },
      isSubmit: false,
      msForm: {
        msTime: '', //  面试时间
        sxTime: '',  //  失效时间
        name: '',    //  面试人姓名
        tel: '',     //  面试联系电话
        videoInterview: '是', //  是否开始视频面试
        address: '', //  面试地址

      },
      msrules: {
        msTime: [
          {type: 'date', required: true, message: '请选择面试时间', trigger: 'change'},
          {validator: vmsTime, trigger: 'change'}
        ],
        sxTime: [
          {type: 'date', required: true, message: '请选择失效时间', trigger: 'change'},
          {validator: vsxTime, trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入机构联系人', trigger: 'blur'},
        ],
        tel: [
          {required: true, message: '请输入机构联系电话', trigger: 'blur'},
        ],
        videoInterview: [
          {required: true, message: '请选择是否开始视频面试', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入机构地址', trigger: 'blur'},
        ],
      },
      biaoqianShade: false, //  标签模块
      visible: false,        //  面试邀请填写信息模块
      lableList: [],         //  标签集合
      chioseList: [],         //  选中的标签集合
      labelName: '',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();//如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      otherShow: 0,  //  0不能看见 1：能看见
      video_interview: 2, //  默认不显示视频面试 1为显示
      dialogVisible: false,
      msImg: ''
    }
  },
  computed: {},
  async created() {
    this.resumeId = Number(this.$route.query.resumeId)
    // 如果地址参数不带简历id就跳往简历列表页
    // if (!this.$route.query.resumeId) {
    //   this.$router.push('/org/receiveResume')
    //   return
    // }
    // 获取简历数据
    await this.init()
    if (this.resumeId) {
      await this.getLanel()
    }

  },
  methods: {
    async init() {
      const loading = this.$loading({
        target: this.$refs.container,
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      await this.$api.apiOrg.detailResume({
        userToken: this.$store.state.user.user_token,
        resumeId: this.$route.query.resumeId ? this.$route.query.resumeId : '',
        jobId: this.$route.query.jobId,
        jobuserId: this.$route.query.jobuserId
      }).then((res) => {
        let data = res.data
        data.lingyu = data.lingyu ? JSON.parse(data.lingyu) : []
        data.zhiwei = data.lingyu ? JSON.parse(data.zhiwei) : []
        if (this.resumeId) {
          data.resume.other_language = !data.resume.other_language ? [] : JSON.parse(data.resume.other_language)
          data.resume.img_ids = !data.resume.img_ids ? [] : data.resume.img_ids.split(',')
          data.resume.lable_ids = !data.resume.lable_ids ? [] : data.resume.lable_ids.split(',')
          data.resume.accessory_path = config.downUrlStr + '?urlFile=' + data.resume.accessory_path + '&userToken=' + this.$route.query.resumeId
          data.resume.file_url = config.downUrlStr + '?urlFile=' + data.resume.file_url + '&userToken=' + data.userinfo.user_id
          this.data = data
          this.user = data.userinfo

          this.lingyu = data.lingyu
          this.zhiwei = data.zhiwei
          this.xingziqiwang = data.xingziqiwang
          this.month_money = data.month_money


          this.states = data.states
          this.video_interview = data.video_interview
          this.otherShow = data.other_show
          this.headimg = data.userinfo.headimg ? config.urlStr + '/' + data.userinfo.headimg :'http://sttts.org.cn/static/home/images/logo.png'

        } else {
          this.data = data
          this.user = data.userinfo
          this.states = data.states
          this.video_interview = data.video_interview
          this.otherShow = data.other_show
          this.headimg = data.userinfo.headimg ? config.urlStr + '/' + data.userinfo.headimg :'http://sttts.org.cn/static/home/images/logo.png'
          this.resume_link = config.urlStr + '/' + data.resume_link
        }
        if (data.deliver_methods === 1) {
          this.isShow = true
        } else if (data.deliver_methods === 2 || data.deliver_methods === 3) {
          if (this.user.sex === 1) {
            this.headimg = config.defaultHeadImg
          } else {
            this.headimg = config.defaultHeadImg2
          }

        }
        loading.close();
        this.isLoading = true
        if (this.resumeId) {

          this.$api.apiOrg.baogaoResume({
            userToken: this.$store.state.user.user_token,
            resumeId: this.$route.query.resumeId,
          }).then(res => {
            this.ruleForm.name = res.data.title
            this.ruleForm.desc = res.data.content
          })
            .catch(e => {
              console.log(e)
            })
        }


      }).catch(e => {
        loading.close();
        this.$message.error(e.info)
      })


    },


    //  去视频面试
    toVideo() {
      this.$api.apiOrg.createRoom({
        userToken: this.$store.state.user.user_token,
        jobsUserId: this.$route.query.jobuserId,
      }).then(res => {
        this.msImg = res.data.qr_code
        this.dialogVisible = true
      }).catch(() => {
        this.$message.error('未到面试时间，请耐心等待')
      })
    },


    back() {
      this.$router.go(-1);
    },
    //  获取标签
    getLanel() {
      this.$api.apiOrg.resumeLabelList({
        userToken: this.$store.state.user.user_token,
        reid: this.$route.query.resumeId
      }).then(res => {
        res.data.map(item => {
          item.state = item.del_time === 1 ? (false) : (true)
        })
        console.log(res.data)
        this.lableList = res.data
      }).catch(() => {
        this.lableList = []
      })
    },
    //  添加标签
    addLabel() {
      if (!this.labelName || this.labelName.length > 6 || this.labelName.length < 2) {
        this.$message.error('请填写自定义标签（2-6个字）')
        return
      }
      this.$api.apiOrg.resumeLabelAdd({
        userToken: this.$store.state.user.user_token,
        reid: this.$route.query.resumeId,
        name: this.labelName
      }).then(() => {
        this.getLanel()
        this.labelName = ''
      }).catch(e => {
        this.$message.error(e.info)
      })
    },
    //  点击标签
    clickLabel(id) {
      this.$api.apiOrg.resumeLabelSubmit({
        userToken: this.$store.state.user.user_token,
        reid: this.$route.query.resumeId,
        idadd: id
      }).then(() => {
        this.getLanel()
      }).catch(e => {
        this.$message.error(e.info)
      })
    },
    //  去举报
    toJubao() {
      this.$router.push({
        path: '/org/complaint',
        query: {
          id: this.$route.query.resumeId,
          state: 5
        }
      })
    },
    //提交面试报告
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.$api.apiOrg.baogaoSubmit({
            userToken: this.$store.state.user.user_token,
            resumeId: this.$route.query.resumeId,
            candidateId: this.user.user_id,
            jobsuserId: this.$route.query.jobId,
            title: this.ruleForm.name,
            content: this.ruleForm.desc
          }).then(() => {
            this.baogaoShade = false
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          })
            .catch(e => {
              this.$message(e.info)
            })


        } else {
          return false;
        }
      });
    },
    //发送面试邀请
    submitForm2(formName) {
      this.isSubmit = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.deliver_methods === 1) {
            this.$api.apiOrg.setResumeState({
              userToken: this.$store.state.user.user_token,
              resume_id: this.$route.query.resumeId,
              jobId: this.$route.query.jobId,
              jobuserId: this.$route.query.jobuserId,
              interviewtime: this.msForm.msTime.getTime() / 1000,  //面试时间
              confirmation: this.msForm.sxTime.getTime() / 1000,  // 确认面试时间
              videoInterview: this.msForm.videoInterview === '是' ? 1 : 2,
              address: this.msForm.videoInterview === '是' ? '' : this.msForm.address,  //面试地点
              conpeople: this.msForm.name,  //面试人
              phone: this.msForm.tel,  // 联系人电话
              states: 2
            }).then(() => {
              this.init()
              this.visible = false
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
            }).catch(e => {
              this.$message(e.info);
              this.isSubmit = false
            })
          } else {
            this.$confirm('发送面试要起需扣除咸豆, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.apiOrg.setResumeState({
                userToken: this.$store.state.user.user_token,
                resume_id: this.$route.query.resumeId,
                jobId: this.$route.query.jobId,
                jobuserId: this.$route.query.jobuserId,
                interviewtime: this.msForm.msTime.getTime() / 1000,  //面试时间
                confirmation: this.msForm.sxTime.getTime() / 1000,  // 确认面试时间
                videoInterview: this.msForm.videoInterview === '是' ? 1 : 2,
                address: this.msForm.videoInterview === '是' ? '' : this.msForm.address,  //面试地点
                conpeople: this.msForm.name,  //面试人
                phone: this.msForm.tel,  // 联系人电话
                states: 2
              }).then(() => {
                this.init()
                this.visible = false
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
              }).catch(e => {
                this.$message(e.info);
                this.isSubmit = false
              })
            }).catch(() => {
              this.isSubmit = false
            });
          }

        } else {
          this.isSubmit = false
          return false;
        }
      });
    },
    // 修改简历状态
    setResumeState(state, str) {
      if (state === 2) {
        this.visible = true
      } else if (state === 10) {
        this.$confirm('您确定要取消面试吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiOrg.cancelInterviewInvitation({
            userToken: this.$store.state.user.user_token,
            resumeId: this.$route.query.resumeId,
            jobId: this.$route.query.jobId,
            jobuserId: this.$route.query.jobuserId,
            // states: state
          }).then(() => {
            this.init()
            this.$message.success('操作成功!');
          }).catch(e => {
            this.$message.error(e.info);
          })
        }).catch(() => {
          // on cancel
        });
      } else {
        this.$confirm('您的操作简历状态为--' + str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiOrg.setResumeState({
            userToken: this.$store.state.user.user_token,
            resume_id: this.$route.query.resumeId,
            jobId: this.$route.query.jobId,
            jobuserId: this.$route.query.jobuserId,
            states: state
          }).then(() => {
            this.init()
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          }).catch(e => {
            this.$message(e.info);
          })

        }).catch(() => {

        })
      }

    }
  },
  filters: {
    //  听说读写
    lang(val) {
      let num = Number(val)
      if (num === 1) {
        return '精通'
      }
      if (num === 2) {
        return '良好'
      }
      if (num === 3) {
        return '一般'
      }
      if (num === 4) {
        return '不具备'
      }
    },
    //  时间转化
    time(val) {
      let num = Number(val)
      if (num === 0) {
        return '至今'
      } else {
        let date1 = new Date(num * 1000)
        let _dates = date1.getFullYear() + "." + ((date1.getMonth() + 1) < 10 ? "0" + (date1.getMonth() + 1) : (date1.getMonth() + 1))
        return _dates
      }
    },
    type(val) {
      // 1全职 2实习 3兼职 4短期
      let num = Number(val)
      if (num === 1) {
        return '全职'
      }
      if (num === 2) {
        return '实习'
      }
      if (num === 3) {
        return '兼职'
      }
      if (num === 4) {
        return '短期'
      }
    },
    // 转化性别
    sex(val) {
      if (Number(val) === 1) {
        return '男'
      } else if (Number(val) === 2) {
        return '女'
      }
    },
    // 根据生日转化年龄
    birthday(val) {
      let nian = new Date().getYear()
      let nian1 = new Date(val * 1000).getYear()
      return (nian - nian1) + '岁'
    },
    // 转化地址
    address(val) {
      let arr = val.split('|')
      return arr[0]
    }
  },
}
</script>

<style scoped lang="scss">
.container {
  width: 900px;
  min-height: 100%;
  position: relative;

  .bg {
    display: block;
    width: 100%;
    height: auto;
  }

  .box1 {
    display: flex;
    align-items: center;
    padding: 25px 50px;
    background: #fff;
    margin-bottom: 10px;

    .left {
      width: 126px;
      height: 156px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .right {
      padding-left: 20px;

      h1 {
        line-height: 56px;
        font-size: 36px;
        font-weight: normal;
      }

      p {
        line-height: 40px;

        span {
          padding: 0 10px;
        }
      }

      div {
        line-height: 40px;

        span {
          padding-right: 10px;

          i {
            position: relative;
            top: 1px;
            font-size: 18px;
            color: #00a2ea;
            padding-right: 5px;
          }
        }

      }
    }
  }

  .box2 {
    padding: 30px 20px;
    background: #fff;
    margin-bottom: 10px;

    .title {
      line-height: 44px;
      font-size: 22px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      > div {
        display: flex;
        align-items: self-start;
        justify-content: flex-start;

        width: 100%;
        line-height: 40px;
        //margin-bottom: 16px;

        span {
          display: block;
          min-width: 100px;
          color: #999;
          font-weight: 500;
        }

        b {
          padding: 0 30px 0 10px;
        }

        div {
          display: flex;
          align-items: self-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          flex: 1;

          .label-text {
            margin-right: 10px;
            color: #00a2ea;
          }
        }
      }
    }

    .items {
      padding: 40px 60px;
      position: relative;

      .time {
        color: #999;
        margin-bottom: 20px;
      }

      .list {
        padding-left: 40px;
      }

      .left-icon {
        position: absolute;
        top: 37px;
        left: 30px;
        width: 20px;
        height: 20px;
        background-color: #90d5f3;
        border-radius: 100%;

        i {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 12px;
          height: 12px;
          background-color: #00a2ea;
          border-radius: 100%;
        }
      }

      .left-shu {
        position: absolute;
        top: 55px;
        left: 40px;
        width: 2px;
        height: 100%;
        background-color: #90d5f3;
      }
    }

    .items2 {
      padding: 28px 60px;

      .list {
        div {
          span {
            color: #333;
          }

          span.times {
            color: #999;
          }
        }
      }

    }
  }

  .box3 {
    position: absolute;
    top: 100px;
    right: -200px;
    width: 200px;
    padding: 20px;

    div {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: left;
      padding-left: 10px;
      margin-bottom: 10px;
      background: #fff;
      border: 1px solid #ddd;
      cursor: pointer;
    }
  }
}

.dialogBox {
  .title {
    font-size: 20px;
    text-align: center;
  }

  .list {
    padding: 20px 0;

    .sub-btn {
      display: block;
      width: 300px;
      margin: 0 auto;
    }
  }

  .list-lable {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .label-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin: 0 20px 20px 0;

      &.active {
        span {
          color: #00a2ea;
          border: 1px solid #00a2ea;
        }

        b {
          color: #00a2ea;
        }

        i {
          color: #00a2ea;
        }
      }

      span {
        display: block;
        padding: 5px;
        border: 1px solid #ddd;
      }

      b {
        padding: 0 5px;
      }

    }
  }

  .add-other {
    padding: 20px 0;
    border-top: 1px solid #ddd;

    p {
      line-height: 30px;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }

  .sub-btn {
    display: block;
    width: 300px;
    margin: 0 auto;
  }
}
</style>
